// Chrome (desktop + Android) sometimes auto-pauses a freshly-started, muted
// autoplay video ("paused to save power") and rejects the in-flight play()
// promise with an AbortError. The Shapes theme's video component (Alpine
// "Video"/"HTMLVideo") doesn't retry, so decorative background videos (e.g.
// the homepage hero) can get stuck paused at frame 0 on load, especially on
// mobile. Confirmed live 2026-08-30 via console: repeated
// "AbortError: play() request was interrupted because ... paused to save
// power" on wthn.com's homepage hero video.
//
// This is a theme-independent safety net — it never touches the vendor's
// Alpine video component, so it survives theme updates/duplicates that
// would otherwise silently drop a patch made inside the vendor's bundle.
// Deliberately scoped to autoplay+muted videos only (decorative background
// video signature) and to a short window near load with currentTime still
// near zero, so it never fights a real visitor who paused a video they were
// actually watching.
(function () {
  var RECOVERY_WINDOW_MS = 8000;
  var loadedAt = Date.now();

  function tryRecover(video) {
    if (!video.autoplay || !video.muted) return;
    if (!video.paused || video.ended) return;
    if (document.visibilityState !== "visible") return;
    if (Date.now() - loadedAt > RECOVERY_WINDOW_MS) return;
    if (video.currentTime > 2) return;

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(function () {
        setTimeout(function () {
          tryRecover(video);
        }, 400);
      });
    }
  }

  // HTMLMediaElement's "pause" event doesn't bubble — a capturing listener
  // on document still receives it during the capture phase.
  document.addEventListener(
    "pause",
    function (e) {
      var video = e.target;
      if (video && video.tagName === "VIDEO") {
        setTimeout(function () {
          tryRecover(video);
        }, 50);
      }
    },
    true
  );

  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible") {
      document.querySelectorAll("video[autoplay][muted]").forEach(tryRecover);
    }
  });

  window.addEventListener("load", function () {
    setTimeout(function () {
      document.querySelectorAll("video[autoplay][muted]").forEach(tryRecover);
    }, 300);
  });
})();
